import type { Locale } from '@tuic/i18n';
import type { MasterExcursion } from '../../generated/oss';
import { CacheTag } from '../../utils';
import { logger } from '@tuic/logger';
import { client } from '../../generated/oss/client.gen';
import { remember, serializeDataToCacheKey } from '@tuic/cache';

type Options = {
  category?: string;
  difficulty?: string;
  port?: string;

  categories?: string[];
  difficulties?: string[];
  ports?: string[];
  operator?: string;
};

const getExcursionsSearchListByPort = async (
  options: Options,
  locale: Locale,
): Promise<MasterExcursion[]> => {
  let { data, error } = await client.get<MasterExcursion[], unknown, false>({
    url: '/excursions/searchByPort',
    query: {
      category: options.categories?.join(',') ?? options.category,
      difficulty: options.difficulties?.join(',') ?? options.difficulty,
      port: options.ports?.join(',') ?? options.port,
      operator: options.operator,
      locale,
    },
  });

  if (error) {
    logger.error(
      `Could not fetch excursion search list data. Locale: ${locale}. Query: ${JSON.stringify(
        options,
      )}`,
    );
    logger.error(error);

    return [];
  }

  return data ?? [];
};

export const cachedGetExcursionsSearchListByPort = (
  options: Options,
  locale: Locale,
): Promise<MasterExcursion[]> =>
  remember(
    serializeDataToCacheKey([
      'oss',
      'getExcursionsSearchListByPort',
      locale,
      options,
    ]),
    () => getExcursionsSearchListByPort(options, locale),
    {
      tags: [
        CacheTag.oss,
        CacheTag.excursionResource,
        CacheTag.getExcursionsSearchListByPort,
      ],
      ttl: 600,
    },
  );
